<template>
  <div class="takeover" :class="{ active: active }">
    <div class="takeover-inner">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  active: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/inc/variables';

.takeover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  z-index: $zindex-modal;
  overflow-y: auto;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 300ms ease,
    visibility 300ms ease;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.takeover-inner {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
